<template>
    <component v-if="mainNav.showNav" :is="currentNavType"></component>
</template>

<script>
    import { defineAsyncComponent } from 'vue';
    import { useMainNavStore } from '@/stores/utils/mainNav';
    import { useScreenWidthStore } from '@/stores/utils/screenWidth';
    import { useUserStore } from '@/stores/user';
    import { useAccountStore } from '@/stores/account';

    const TopNav = process.env.VUE_APP_TYPE === 'prospectpro'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "TopNavPp" */ '@/components/navigation/prospectpro/TopNav'))
        : process.env.VUE_APP_TYPE === 'developers'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "TopNavDev" */ '@/components/navigation/developers/TopNav'))
        : process.env.VUE_APP_TYPE === 'bedrijfsdata'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "TopNavBedrijfsdata" */ '@/components/navigation/bedrijfsdata/TopNav'))
        : process.env.VUE_APP_TYPE === 'builder'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "TopNavBuilder" */ '@/components/navigation/builder/TopNav'))
        : '';

    const SideNav = process.env.VUE_APP_TYPE === 'prospectpro'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "SideNavPp" */ '@/components/navigation/prospectpro/SideNav'))
        : process.env.VUE_APP_TYPE === 'developers'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "SideNavDev" */ '@/components/navigation/developers/SideNav'))
        : process.env.VUE_APP_TYPE === 'bedrijfsdata'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "SideNavBedrijfsdata" */ '@/components/navigation/bedrijfsdata/SideNav'))
        : '';

    const TopNavSearch = process.env.VUE_APP_TYPE === 'search'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "TopNavSearch" */ '@/components/navigation/TopNavSearch'))
        : '';

    const TopNavAccounts = process.env.VUE_APP_TYPE !== 'search' && process.env.VUE_APP_TYPE !== 'builder'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "TopNavAccounts" */ '@/components/navigation/TopNavAccounts'))
        : '';

    export default {
        name: 'MainNav',
        components: {
            TopNav,
            TopNavAccounts,
            SideNav,
            TopNavSearch
        },
        computed: {
            mainNav() {
                return useMainNavStore();
            },
            screenWidthStore() {
                return useScreenWidthStore();
            },
            userStore() {
                return useUserStore();
            },
            accountStore() {
                return useAccountStore();
            },
            currentNavType() {
                if(process.env.VUE_APP_HAS_ONBOARDING === 'true' && this.accountStore.hasAccountId && this.accountStore.hasFullAccount && (this.accountStore.account?.onboarding_status === 0 || this.accountStore.account?.onboarding_status > 1)) {
                    return 'TopNavAccounts';
                } else if (process.env.VUE_APP_TYPE === 'search' && this.$route.name === 'search-result') {
                    return 'TopNavSearch';
                } else if (process.env.VUE_APP_TYPE === 'builder') {
                    return 'TopNav';
                } else if (this.accountStore.hasAccountId) {
                    if(this.screenWidthStore.width >= 769) {
                        return 'SideNav';
                    } else {
                        return 'TopNav';
                    }
                } else {
                    return 'TopNavAccounts';
                }
            },
        },
        methods: {
            toggleNav() {
                if (this.userStore.isAuthenticated) {
                    this.mainNav.toggleNav(true);
                } else if (process.env.VUE_APP_TYPE === 'search' && this.$route.name === 'search-result') {
                    this.mainNav.toggleNav(true);
                } else if (process.env.VUE_APP_TYPE === 'builder') {
                    this.mainNav.toggleNav(true);
                } else {
                    this.mainNav.toggleNav(false);
                }
            },
        },
        watch: {
            $route() {
                this.toggleNav();
            }
        },
        created() {
            this.toggleNav();
        }
    }
</script>
